RivalIQ.apps.Site.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const CREDIT_CARD_BILLING_METHOD_NAME = 'Credit Card';

    const RenewFinishView = Marionette.ItemView.extend({
        className: 'renew-finish',
        template: '#siteRenewalCenterRenewFinishTemplate'
    });

    const RenewFinishCreditCardView = Marionette.ItemView.extend({
        className: 'renew-finish',
        template: '#siteRenewalCenterRenewCreditCardTemplate'
    });

    const RenewErrorView = Marionette.ItemView.extend({
        className: 'renew-error',
        template: '#siteRenewalCenterRenewErrorTemplate'
    });

    const RenewView = Marionette.ItemView.extend({
        ui: {
            email: '#emailAddress'
        },
        events: {
            'input @ui.email': 'onEmailChange'
        },
        getTemplate: function () {
            const me = this;
            if (me.model.get('billingMethod') === CREDIT_CARD_BILLING_METHOD_NAME) {
                // false is only falsey value that won't cause ViewNotValid error
                return false;
            } else {
                return '#siteRenewalCenterRenewInvoiceTemplate';
            }
        },
        onEmailChange: function () {
            const me = this;
            const email = me.ui.email.val();

            if (RivalIQ.utils.email.validEmailAddress(email)) {
                me.model.set('email', email);
                me.triggerMethod('button:enable');
            } else {
                me.model.unset('email');
                me.triggerMethod('button:disable');
            }
        },
        onBeforeShow: function () {
            const me = this;
            if (me.model.get('billingMethod') === CREDIT_CARD_BILLING_METHOD_NAME) {
                $('.done-btn').hide();

                // NOTE no more steps, so finish the work
                me.done();
            }
        },
        onShow: function () {
            const me = this;
            me.ui.email.focus();
            // validated the initial email value
            setTimeout(function () {
                me.onEmailChange();
            }, 0);
        },
        saveRenewalChoice: function () {
            const me = this;
            const data = me.model.pick('accountId', 'choice', 'email');
            if (!data.email) {
                data.email = me.model.get('ownerEmail');
            }
            const renew = new App.models.Renewal(data);
            const csrfToken = $('#_csrf').val();
            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.RenewalCenterPickedRenew, {
                accountId: me.model.get('accountId')
            });
            // if renew model validation fails here (it should not) renew.save() returns false
            // instead of jqXHR, so .done and .fail would cause type error
            if (renew.isValid()) {
                const response = renew.save({
                    _csrf: csrfToken
                }).done(function renewalSaveSuccess() {
                    if (me.model.get('billingMethod') === CREDIT_CARD_BILLING_METHOD_NAME) {
                        me.triggerMethod('creditCardSuccess');
                    } else {
                        me.triggerMethod('invoiceSuccess');
                    }
                }).fail(function (error) {
                    me.triggerMethod('renewalSaveError');
                });
                return response;
            } else {
                me.triggerMethod('renewalSaveError');
                throw new Error(`couldn't validate renewal: ${renew.validationError}`);
            }
        },
        done: function () {
            const me = this;
            me.saveRenewalChoice();
        }
    });

    const HelpView = Marionette.ItemView.extend({
        className: 'help-view',
        template: '#siteRenewalCenterHelpTemplate',
        ui: {
            calendly: 'a.by-calendly',
            email: 'a.by-email',
            phone: 'a.by-phone'
        },
        events: {
            'click @ui.email': 'onClickedEmail',
            'click @ui.phone': 'onClickedPhone',
            'click @ui.calendly': 'onClickedCalendly'
        },
        onShow: function () {
            const me = this;
            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.RenewalCenterPickedHelp, {
                accountId: me.model.get('accountId')
            });

            $.post('/api/triggers', {
                type: 'email',
                trigger_type: 'viewed_renewal_center_modify_or_cancel',
                _csrf: $('#_csrf').val(),
                data: {
                    accountId: me.model.get('accountId'),
                    accountUuid: me.model.get('accountUuid')
                }
            });
        },
        onClickedCalendly: function () {
            const me = this;
            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.RenewalCenterClickedCalendly, {
                accountId: me.model.get('accountId')
            });
        },
        onClickedEmail: function () {
            const me = this;
            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.RenewalCenterClickedEmail, {
                accountId: me.model.get('accountId')
            });
        },
        onClickedPhone: function () {
            const me = this;
            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.RenewalCenterClickedPhone, {
                accountId: me.model.get('accountId')
            });
        }
    });

    const WelcomeView = Marionette.ItemView.extend({
        className: 'welcome-view',
        template: '#siteRenewalCenterWelcomeTemplate',
        ui: {
            radio: '.radio'
        },
        events: {
            'change @ui.radio': 'onRadioChange'
        },
        onRadioChange: function (e) {
            const me = this;
            if (e) {
                const value = $(e.target).val();
                me.model.set('choice', value);
                me.triggerMethod('button:enable');
            }
        },
        next: function () {
            const me = this;
            const choice = me.model.get('choice');
            const options = {
                model: me.model
            };

            let view = null;

            switch (choice) {
                case 'renew':
                    view = new RenewView(options);
                    break;
                case 'help':
                    view = new HelpView(options);
                    break;
                default:
                    // this shouldn't happen but if it does show an error
                    view = new RenewErrorView(options);
            }

            return view;
        },
        templateHelpers: function () {
            return {
                formatUSD: function (amount) {
                    if (_.isFinite(amount)) {
                        return amount.toLocaleString('en-us', {
                            style: 'currency',
                            currency: 'USD',
                            minimumFractionDigits: 2
                        });
                    } else {
                        return '$--';
                    }
                }
            };
        }
    });

    views.RenewalCenterLayout = Marionette.LayoutView.extend({
        template: '#siteRenewalCenterLayoutTemplate',
        ui: {
            container: '.renewal-center-form',
            nextBtn: '.next-btn',
            doneBtn: '.done-btn'
        },
        regions: {
            form: '.renewal-center-form'
        },
        events: {
            'click @ui.nextBtn': 'onNext',
            'click @ui.doneBtn': 'onDone'
        },
        childEvents: {
            'button:enable': 'onButtonEnable',
            'button:disable': 'onButtonDisable',
            'renewalSaveError': 'onRenewalSaveError',
            'invoiceSuccess': 'onInvoiceSuccess',
            'creditCardSuccess': 'onCreditCardSuccess'
        },
        onRenewalSaveError: function () {
            const me = this;
            me.currentView = new RenewErrorView({
                model: me.model
            });
            me.showView();
        },
        onInvoiceSuccess: function () {
            const me = this;

            me.currentView = new RenewFinishView({
                model: me.model
            });
            me.showView();
        },
        onCreditCardSuccess: function () {
            const me = this;

            me.currentView = new RenewFinishCreditCardView({
                model: me.model
            });
            me.showView();
        },
        onNext: function () {
            const me = this;

            me.currentView = me.currentView.next();
            me.showView();

            me.ui.nextBtn.toggleClass('disabled', true);
        },
        onDone: function () {
            const me = this;

            me.currentView = me.currentView.done();
            me.showView();
        },
        showView: function () {
            const me = this;

            if (me.currentView) {
                me.form.show(me.currentView);
            }
            if (me.currentView?.next) {
                me.showNext();
            } else if (me.currentView?.done) {
                me.showDone();
            } else {
                me.ui.nextBtn.toggleClass('hidden', true);
                me.ui.doneBtn.toggleClass('hidden', true);
                me.activeButton = null;
            }
        },
        showNext: function () {
            const me = this;

            me.ui.nextBtn.toggleClass('hidden', false);
            me.ui.nextBtn.toggleClass('disabled', true);
            me.activeButton = me.ui.nextBtn;
            me.ui.doneBtn.toggleClass('hidden', true);
        },
        showDone: function () {
            const me = this;

            me.ui.nextBtn.toggleClass('hidden', true);
            me.ui.doneBtn.toggleClass('hidden', false);
            me.ui.doneBtn.toggleClass('disabled', true);
            me.activeButton = me.ui.doneBtn;
        },
        onKeydown: function (e) {
            const me = this;

            if (e.which === 13 && me.activeButton) {
                me.activeButton.click();
            }
        },
        onButtonEnable: function (childView, button) {
            const me = this;
            if (me.activeButton && !button) {
                me.activeButton.toggleClass('disabled', false);
            } else if (button === 'next') {
                me.nextBtn.toggleClass('disabled', false);
            } else if (button === 'done') {
                me.doneBtn.toggleClass('disabled', false);
            }
        },
        onButtonDisable: function (childView, button) {
            const me = this;
            if (me.activeButton && !button) {
                me.activeButton.toggleClass('disabled', true);
            } else if (button === 'next') {
                me.nextBtn.toggleClass('disabled', true);
            } else if (button === 'done') {
                me.doneBtn.toggleClass('disabled', true);
            }
        },
        onRender: function () {
            const me = this;

            const options = {
                model: me.model
            };

            me.currentView = new WelcomeView(options);
            me.showView();
            $(document).keydown(me.onKeydown.bind(me));
        }
    });
});
